import { google_fonts_list } from 'data/google_fonts'
import AllIcons from './AllIcons'

const textAlignmentValues = [
  {
    title: 'Start',
    desc: 'Aligns text to the start on the main axis.',
    icon: AllIcons.text_left,
    value: 'start',
  },
  {
    title: 'Center',
    desc: 'Centers text along the main axis.',
    icon: AllIcons.text_center,
    value: 'center',
  },
  {
    title: 'End',
    desc: 'Aligns text to the end on the main axis.',
    icon: AllIcons.text_right,
    value: 'end',
  },
  {
    title: 'Justify',
    desc: 'Expands text to fill the entire width by adjusting spacing between words and characters.',
    icon: AllIcons.text_justify,
    value: 'justify',
  },
]

//

export const typography_styles = [
  {
    key: 'font_family',
    title: 'Font family',
    type: 'select',
    value: 'primary_font',
    is_required: false,
    style_group: 'typography',
    drop_down_values: [
      { label: 'Primary font', value: 'primary_font' },
      { label: 'Title Font', value: 'title_font' },
      { label: 'Body font', value: 'body_font' },
      // ...google_fonts_list.map((font) => ({
      //   label: font.family,
      //   value: font.family,
      // })),
    ],
  },
  {
    key: 'font_weight',
    title: 'Font weight',
    style_group: 'typography',

    value: '500',
    type: 'select',
    value: 'primary_font',
    is_required: false,
    drop_down_values: [
      { label: '100 (Thin)', value: '100' },
      { label: '200 (Extra-Light)', value: '200' },
      { label: '300 (Light)', value: '300' },
      { label: '400 (Regular)', value: '400' },
      { label: '500 (Medium)', value: '500' },
      { label: '600 (Semi-Bold)', value: '600' },
      { label: '700 (Bold)', value: '700' },
      { label: '800 (Extra-Bold)', value: '800' },
    ],
  },
  {
    key: 'text_size',
    style_group: 'typography',
    value: '20px',
    type: 'input-px',
    title: 'Text size',
    is_required: false,
  },
  {
    key: 'line_height',
    style_group: 'typography',
    value: '20px',
    type: 'input-px',
    title: 'Line Height',
    is_required: false,
  },
  {
    key: 'text_color',
    style_group: 'typography',
    value: '#000000',
    type: 'color',
    title: 'Text Color',
    is_required: false,
  },
  {
    key: 'text_align',
    title: 'Text alignment',
    style_group: 'typography',
    type: 'select',
    value: 'start',
    is_required: false,
    drop_down_values: textAlignmentValues,
  },
  {
    key: 'line_clamp',
    title: 'Line Clamp',
    style_group: 'typography',
    value: '',
    type: 'select',
    value: '',
    is_required: false,
    drop_down_values: [
      { label: 'line-limit-1', value: 1 },
      { label: 'line-limit-2', value: 2 },
      { label: 'line-limit-3', value: 3 },
      { label: 'line-limit-4', value: 4 },
      { label: 'line-limit-5', value: 5 },
      { label: 'line-limit-6', value: 6 },
      { label: 'line-limit-none', value: 'none' },
      { label: 'Select Line Clamp ', value: '' },
    ],
  },
]
